import {ContentProgression} from "../../constants";
import {Injectable} from "@angular/core";

export enum Language {
    en=<any>"ENGLISH",
    es=<any>"SPANISH"
}

@Injectable()
export class StudentConfiguration {
    assignmentMethod:string;
    pronunciationCorrectness:number;
    gradeBand:string;
    instructionLanguage:string;
    interventionWaitTime:number;
    contentProgression:ContentProgression;
    protocolDuration:number;
    isAudioAllowed:boolean;
    glossaryAvailable:boolean;
    glossaryIsSpanishEnabled:boolean;

    public isInstructionSpanishEnabled(): boolean {
        let val: string = String(Language.es.valueOf());
        return this.instructionLanguage === val;
    }

    public getContentProgression(): ContentProgression {
        return this.contentProgression;
    }
}
